import { Category } from "@faire/deprecated-retailer-visitor-shared/models/Category/Category";
import { ICategory } from "@faire/web-api--source/indigofair/data/ICategory";

/**
 * Builds a category model from the given category url ids and the provided category tree
 *
 * NOTE: Should only be used from the router of the category and suppliers page
 *
 * @param categoryUrlIds - url ids of the category
 * @param serializedCategories - the category tree to build the category model from
 * @returns A category chain of the category model
 */
export const fromUrlIds = (
  categoryUrlIds: string[],
  serializedCategories: ICategory[]
): Category | undefined => {
  if (categoryUrlIds.length === 0) {
    return undefined;
  }

  const [categoryUrlId, ...subcategoryUrlIds] = categoryUrlIds;

  if (!categoryUrlId) {
    return undefined;
  }

  const matchingCategory = serializedCategories.find(
    (cat) => cat.url_id?.toLowerCase() === categoryUrlId.toLowerCase()
  );
  return new Category({
    name: matchingCategory?.name ?? categoryUrlId ?? "",
    urlId: { id: categoryUrlId },
    pathIdentifier: matchingCategory?.path_identifier,
    subCategory: fromUrlIds(
      subcategoryUrlIds,
      matchingCategory?.sub_categories ?? []
    ),
    isProductFirstCategory: matchingCategory
      ? (matchingCategory.is_product_based ?? false)
      : undefined,
    uniqueDisplayName: matchingCategory?.unique_display_name,
  });
};
